import { url } from '../../_services/apiurl';
import { authHeader } from '../../_helpers/auth-header';
export async function staffApi(path = '', method = 'GET', body) {
  const response = await fetch(`${url}/staff-access${path}`, { method, headers: { ...authHeader(), 'Content-Type': 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
  const data = await response.json();
  if (!response.ok) throw new Error(data.err || 'Unable to complete request.');
  return data;
}
